import { Component } from '@angular/core';
import { FormBuilder, Validators } from "@angular/forms";
import { EmployeeService } from '../employee.service';
import * as fileSaver from 'file-saver';

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.css']
})

export class DownloadComponent {
  isSubmitted = false;
 
 ngonit
  // City Names
  Option: any = [{"name":'ALL', "value":"-2"},{"name":'Unassigned', "value":"-1"}]
  
  constructor(public fb: FormBuilder,private employeeService: EmployeeService) { }

  ngOnInit() {
    this.onSubmit();
  }

  /*########### Form ###########*/
  registrationForm = this.fb.group({
    option: ['', [Validators.required]]
  })


  // Choose city using select dropdown
  changeOption(e) {
    //console.log(e.value)
    this.option.setValue(e.target.value, {
      onlySelf: true
    })
  }

  // Getter method to access formcontrols
  get option() {
    return this.registrationForm.get('option');
  }

  /*########### Template Driven Form ###########*/
  onSubmit() {
    console.log(this.registrationForm.value.option);
    this.isSubmitted = true;
    if (!this.registrationForm.valid) {
      return false;
    } else {
    this.employeeService.downloadFile(this.registrationForm.value.option).subscribe((response: any) => { //when you use stricter type checking
			let blob:any = new Blob([response], { type: 'vnd.ms-excel' });
			const url = window.URL.createObjectURL(blob);
			//window.open(url);
			//window.location.href = response.url;
			fileSaver.saveAs(blob, this.getFormattedDate() +'.xlsx');
		//}), error => console.log('Error downloading the file'),
		}, err => {
      console.log(err);
      console.log("having error");
    }), (error: any) => console.log('Error downloading the file'), //when you use stricter type checking
                 () => console.info('File downloaded successfully');

  }
}
  getFormattedDate() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();
    return yyyy + mm + dd;
  }
}